import { Button } from "@mui/material";
import React, { useState } from "react";
import CalendarPopup from "../../Components/Popups/CalendarPopup";
import Day from "./Day";

export default function Calendar() {
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const clickEvent = (event) => {
    setSelectedEvent(event?.id);
    setPopupOpen(true);
  };
  return (
    <div>
      <div>
        <Button onClick={() => clickEvent(null)}>Add Event</Button>
      </div>
      <div style={{ display: "flex" }}>
        {[...new Array(7).keys()].map((k) => (
          <Day dayOfWeek={k} clickEvent={(e) => clickEvent(e)} />
        ))}
      </div>
      {popupOpen && (
        <CalendarPopup
          onClose={() => setPopupOpen(false)}
          open={popupOpen}
          eventId={selectedEvent}
        />
      )}
    </div>
  );
}
